import axios from 'axios'
import { openNewTabBlobFile } from 'utils/helper'

export const getFinanceJoinedInvoice = ({ id, params }) => {
  return axios.get(`/finance/joinedSalesInvoices/${id}`, { params })
}

export const addFinanceJoinedInvoice = (data) => {
  return axios.post(`/finance/joinedSalesInvoices`, data)
}

export const editFinanceJoinedInvoice = (data) => {
  return axios.put(`/finance/joinedSalesInvoices/${data.id}`, data)
}

export const deleteFinanceJoinedInvoice = (id) => {
  return axios.delete(`/finance/joinedSalesInvoices/${id}`)
}

export const deleteOnAddJoinFinanceInvoiceAttachment = (url) => {
  return axios.delete('/finance/joinedSalesInvoices/attachments', { data: { url } })
}

export const deleteOnEditJoinFinanceInvoiceAttachment = (id, url) => {
  return axios.delete(`/finance/joinedSalesInvoices/${id}/attachments`, { data: { url } })
}

export const createPdfJoinedSalesInvoice = (id) => {
  return axios
    .get(`/finance/joinedSalesInvoices/${id}/print`, { responseType: 'blob' })
    .then((response) => {
      openNewTabBlobFile(response.data)
      return Promise.resolve(true)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export const getJoinInvoiceSmsTemplate = (id) => {
  return axios.get(`/finance/joinedSalesInvoices/${id}/sms`)
}

export const sendJoinInvoiceSms = (id, data) => {
  return axios.post(`/finance/joinedSalesInvoices/${id}/sms`, data)
}

export const getJoinInvoiceEmailTemplate = (id) => {
  return axios.get(`/finance/joinedSalesInvoices/${id}/email`)
}

export const sendJoinInvoiceEmail = (id, data) => {
  return axios.post(`/finance/joinedSalesInvoices/${id}/email`, data)
}

export const getJoinInvoiceWaTemplate = (id) => {
  return axios.get(`/finance/joinedSalesInvoices/${id}/whatsapp`)
}

export const getJoinInvoiceInputWhatsappTemplate = (id) => {
  return axios.get(`/finance/joinedSalesInvoices/${id}/inputWhatsapp`)
}

export const sendJoinInvoiceWhatsapp = (payload) => {
  const { id, ...body } = payload
  return axios.post(`/finance/joinedSalesInvoices/${id}/whatsapp`, body)
}

export const inputMassSendEmailJoinInvoice = (data) => {
  return axios.post('/finance/joinedSalesInvoices/inputMassEmail', data)
}

export const executeMassSendEmailJoinInvoice = (data) => {
  return axios.post('/finance/joinedSalesInvoices/executeMassEmail', data)
}

export const inputMassSendWhatsappJoinInvoice = (data) => {
  return axios.post('/finance/joinedSalesInvoices/inputMassWhatsapp', data)
}

export const executeMassSendWhatsappJoinInvoice = (data) => {
  return axios.post('/finance/joinedSalesInvoices/executeMassWhatsapp', data)
}

export const getJoinedInvoiceLog = ({ id, params } = {}) => {
  return axios.get(`/finance/joinedSalesInvoices/${id}/logs`, { params })
}
